import { useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import '../../layouts/AnimatedLogo.css'
import syncLogo from '../../assets/AWLO1.png'

interface AnimatedLogoProps {
  size?: 'default' | 'header' | 'footer'
}

export default function AnimatedLogo({ size = 'default' }: AnimatedLogoProps) {
  const logoContainerRef = useRef<HTMLDivElement>(null)
  const navigate = useNavigate()

  useEffect(() => {
    const currentRef = logoContainerRef.current
    if (currentRef) {
      currentRef.classList.add('animated-logo--visible')
      currentRef.classList.remove('animated-logo--hidden')
    }
  }, [])

  const handleLogoClick = () => {
    navigate('/')
  }

  return (
    <div 
      ref={logoContainerRef} 
      className={`animated-logo animated-logo--hidden animated-logo--${size} cursor-pointer transition-opacity hover:opacity-80 active:opacity-70`}
      onClick={handleLogoClick}
      role="button"
      tabIndex={0}
      aria-label="Retour à la page d'accueil"
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault()
          handleLogoClick()
        }
      }}
    >
      <div className="animated-logo__container">
        <img 
          src={syncLogo}
          alt="SYNC" 
          className="animated-logo__image"
        />
      </div>
    </div>
  )
}

